var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03833 4.83572L15.0929 4.8535L13.7857 8.00261L9.03833 4.83572Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7857 8.00261L10.4076 7.99523L9.03833 4.83572L13.7857 8.00261Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2683 1.60391L13.7858 8.00262L15.093 4.85351L22.2683 1.60391Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4079 7.99524L1.9082 1.52826L9.0386 4.83573L10.4079 7.99524Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8348 10.7608L22.8907 8.84267L22.6869 9.74187L18.8348 10.7608Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5584 10.8222L18.8348 10.7608L22.6869 9.74185L22.5584 10.8222Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0238 12.3853L17.1835 11.0429L18.8348 10.7608L22.0238 12.3853Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5584 10.8222L22.0238 12.3853L18.8348 10.7608L22.5584 10.8222Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28881 10.74L1.43209 9.70412L1.22583 8.79955L5.28881 10.74Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8907 8.84264L18.8348 10.7608L18.6678 5.84576L22.8907 8.84264Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6679 5.84576L18.8348 10.7608L17.1835 11.0428L18.6679 5.84576Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56314 10.7904L1.43213 9.70413L5.28885 10.74L1.56314 10.7904Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10217 12.3624L5.28889 10.74L6.97022 11.0279L2.10217 12.3624Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56311 10.7904L5.28882 10.74L2.1021 12.3624L1.56311 10.7904Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50053 5.81021L5.28881 10.74L1.22583 8.79956L5.50053 5.81021Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97027 11.0279L5.28894 10.74L5.50066 5.81021L6.97027 11.0279Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6066 20.3216L15.833 20.3533L17.1064 20.9992L15.6066 20.3216Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09045 21.0083L8.32132 20.359L8.51219 20.3269L7.09045 21.0083Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3936 9.1656L22.6869 9.74187L22.8907 8.84267L23.3936 9.1656Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8316 17.5982L22.52 23.0484L17.1063 20.9992L23.8316 17.5982Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1835 11.0428L13.7858 8.00261L18.6679 5.84576L17.1835 11.0428Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5585 10.8222L22.6869 9.74185L23.2576 10.1343L22.5585 10.8222Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6678 5.84577L23.5065 5.0787L22.8907 8.84265L18.6678 5.84577Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50061 5.81021L10.4077 7.99525L6.97023 11.0279L5.50061 5.81021Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72229 9.12221L1.22588 8.79955L1.43214 9.70412L0.72229 9.12221Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09043 21.0083L1.56944 23.0777L0.255859 17.6005L7.09043 21.0083Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0238 12.3852L22.5584 10.8222L23.0255 11.1209L22.0238 12.3852Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56317 10.7904L0.86084 10.0966L1.43215 9.70413L1.56317 10.7904Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22585 8.79955L0.627075 5.01263L5.50055 5.8102L1.22585 8.79955Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7076 12.6956L22.0239 12.3853L23.8316 17.5982L18.7076 12.6956Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1021 12.3624L1.09558 11.0892L1.5631 10.7903L2.1021 12.3624Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1063 20.9992L19.523 16.9182L23.8316 17.5982L17.1063 20.9992Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7076 12.6956L23.8316 17.5982L19.523 16.9182L18.7076 12.6956Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50738 12.6815L0.255859 17.6005L2.1021 12.3624L5.50738 12.6815Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0238 12.3853L18.7076 12.6956L17.1835 11.0429L22.0238 12.3853Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10217 12.3624L6.97022 11.0279L5.50745 12.6815L2.10217 12.3624Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.255859 17.6005L4.69118 16.9173L7.09043 21.0083L0.255859 17.6005Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69118 16.9173L0.255859 17.6005L5.50738 12.6815L4.69118 16.9173Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1835 11.0429L18.7076 12.6956L13.5414 12.7051L17.1835 11.0429Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5414 12.7051L13.7858 8.00261L17.1835 11.0428L13.5414 12.7051Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97021 11.0279L10.4077 7.99521L10.7207 12.7021L6.97021 11.0279Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7207 12.7021L5.50745 12.6815L6.97022 11.0279L10.7207 12.7021Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2683 1.60391L23.5065 5.07871L18.6678 5.84578L22.2683 1.60391Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6679 5.84578L13.7858 8.00262L22.2683 1.60391L18.6679 5.84578Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9082 1.52826L10.4079 7.99524L5.50081 5.8102L1.9082 1.52826Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50055 5.8102L0.627075 5.01263L1.90795 1.52826L5.50055 5.8102Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4076 7.99521L13.7857 8.00259L13.5413 12.7051L10.4076 7.99521Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5413 12.7051L10.7206 12.7021L10.4076 7.99521L13.5413 12.7051Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1064 20.9992L16.6207 16.7646L19.523 16.9182L17.1064 20.9992Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09053 21.0083L4.69128 16.9173L7.63482 16.7637L7.09053 21.0083Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5414 12.7051L18.7076 12.6956L16.6589 14.6817L13.5414 12.7051Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7076 12.6956L16.6207 16.7646L16.6589 14.6817L18.7076 12.6956Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.523 16.9182L16.6207 16.7646L18.7076 12.6956L19.523 16.9182Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58684 14.6763L5.50745 12.6815L10.7207 12.7021L7.58684 14.6763Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50745 12.6815L7.58684 14.6763L7.63479 16.7638L5.50745 12.6815Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50748 12.6815L7.63482 16.7638L4.69128 16.9173L5.50748 12.6815Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1985 21.1122L17.1063 20.9992L16.0915 21.5711L14.1985 21.1122Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14904 21.5794L7.09045 21.0083L10.1814 21.1159L8.14904 21.5794Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6589 14.6817L14.7964 13.8086L13.5414 12.7051L16.6589 14.6817Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7206 12.7021L9.45882 13.8043L7.58679 14.6762L10.7206 12.7021Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2332 19.9268L17.1063 20.9992L14.1985 21.1122L14.2332 19.9268Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1063 20.9992L14.2332 19.9268L13.9707 17.7447L17.1063 20.9992Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9707 17.7447L16.6206 16.7646L17.1063 20.9992L13.9707 17.7447Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0439 15.305L14.7963 13.8085L16.6588 14.6816L14.0439 15.305Z",
    fill: "#243343",
    stroke: "#243343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6207 16.7646L14.0439 15.305L16.6588 14.6817L16.6207 16.7646Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.181 19.9294L10.1814 21.1159L7.09045 21.0083L10.181 19.9294Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09045 21.0083L10.4478 17.7451L10.181 19.9294L7.09045 21.0083Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4478 17.7451L7.09045 21.0083L7.63475 16.7637L10.4478 17.7451Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2302 15.3033L7.58679 14.6762L9.45882 13.8043L10.2302 15.3033Z",
    fill: "#243343",
    stroke: "#243343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63474 16.7637L7.58679 14.6762L10.2302 15.3033L7.63474 16.7637Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7964 13.8086L14.044 15.3051L13.5414 12.7051L14.7964 13.8086Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45886 13.8043L10.7207 12.7021L10.2303 15.3033L9.45886 13.8043Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.044 15.3051L13.4442 14.1873L13.5414 12.7051L14.044 15.3051Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.845 14.1854L10.7206 12.7021L13.5413 12.7051L10.845 14.1854Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5414 12.7051L13.4442 14.1873L10.8451 14.1854L13.5414 12.7051Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2302 15.3033L10.7206 12.7021L10.8451 14.1854L10.2302 15.3033Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0915 21.5711L14.0292 21.9917L14.1985 21.1122L16.0915 21.5711Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1814 21.1159L10.3595 21.9959L8.14905 21.5794L10.1814 21.1159Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0439 15.305L16.6206 16.7646L13.9707 17.7447L14.0439 15.305Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4478 17.7452L7.63477 16.7637L10.2303 15.3033L10.4478 17.7452Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4442 14.1873L14.044 15.305L13.516 17.4273L13.4442 14.1873Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9707 17.7447L13.5159 17.4273L14.0439 15.305L13.9707 17.7447Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8451 14.1854L10.9031 17.4274L10.2302 15.3033L10.8451 14.1854Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2302 15.3033L10.9031 17.4274L10.4478 17.7452L10.2302 15.3033Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8451 14.1854L13.4442 14.1873L13.5159 17.4273L10.8451 14.1854Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5159 17.4273L10.9031 17.4274L10.8451 14.1854L13.5159 17.4273Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2338 19.9268L14.199 21.1122L14.0292 21.9917L14.2338 19.9268Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3599 21.9959L10.1814 21.1159L10.181 19.9294L10.3599 21.9959Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0057 19.5784L14.0291 21.9917L10.3595 21.9959L14.0057 19.5784Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0291 21.9917L14.0056 19.5784L14.2337 19.9268L14.0291 21.9917Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.181 19.9294L10.4259 19.5804L10.3599 21.9959L10.181 19.9294Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3595 21.9959L10.4253 19.5804L14.0057 19.5784L10.3595 21.9959Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9707 17.7447L14.2338 19.9268L14.0057 19.5784L13.9707 17.7447Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4259 19.5804L10.181 19.9294L10.4485 17.7451L10.4259 19.5804Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5577 17.6064L13.5159 17.4273L13.9707 17.7447L13.5577 17.6064Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 17.6066L10.9031 17.4274L13.5159 17.4273L10.8945 17.6066Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5159 17.4273L13.5577 17.6064L10.8945 17.6066L13.5159 17.4273Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4479 17.7451L10.9031 17.4274L10.8946 17.6066L10.4479 17.7451Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.006 19.5784L13.8491 17.9357L13.971 17.7447L14.006 19.5784Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9708 17.7447L13.8491 17.9356L13.5577 17.6064L13.9708 17.7447Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4479 17.7451L10.6034 17.9362L10.4253 19.5804L10.4479 17.7451Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8946 17.6066L10.603 17.9362L10.4479 17.7451L10.8946 17.6066Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.603 17.9362L13.8492 17.9356L14.0057 19.5783L10.603 17.9362Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0057 19.5784L10.4253 19.5804L10.603 17.9362L14.0057 19.5784Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5578 17.6064L13.8492 17.9356L10.603 17.9362L13.5578 17.6064Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.603 17.9362L10.8946 17.6066L13.5578 17.6064L10.603 17.9362Z",
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.832a44bbf693c7c4ce76a5434b9f696c.svg";
export { ForwardRef as ReactComponent };